import React, { Component } from 'react'
import autobind from 'autobind-decorator'
import update from 'react-addons-update'
import PropTypes from 'prop-types'

import FaCaretLeft from 'react-icons/fa/caret-left'

import WorkMedia from './WorkMedia'
import WorkStats from './WorkStats'
import WorkSidebar from './WorkSidebar'
import WorkNoAccess from './noAccess'
import WorkLoading from './WorkLoading'

import API from '../api'

@autobind
class Work extends Component {
  constructor (props) {
    super(props)
    let work = {}
    this.state = {id: this.props.match.params.workId, work, loading: true, user: {}}
  }

  componentDidMount () {
    this.getWork()
  }

  componentWillMount () {
    API.get('/v3/me?include=account.names,account.avatar,account.email_identity.email,account.teacher_type.school.names,account.student_type,account.policy').then(({data}) => this.setState({user: data.account}))
  }

  getWork () {
    let {id} = this.state
    return API.get(`/v3/works/${id}?include=work.names,work.details,work.timestamps,work.media,work.medium.image,work.medium.details,work.medium.policy,work.comments,work.comment.timestamps,work.comment.account,work.comment.account.student_type,work.comment.account.names,work.comment.account.avatar,work.comment.details,work.comment.geolocation.details,work.school,work.school.names,work.school.policy,work.year_group,work.year_group.names,work.year_group.order,work.year_group.id,work.student_type,work.student_type.account,work.student_type.account.names,work.student_type.account.avatar,work.flag,work.recaptcha,work.policy,work.work_counters,work.comment_counters,work.status,work.lesson.details,work.lesson.status,work.presentation,work.presentation.details,work.presentation.account,work.presentation.account.names,work.presentation.teaching_resources,work.presentation.teaching_resources.title,work.presentation.teaching_resources,work.presentation.teaching_resource.source_type,work.presentation.teaching_resource.external_id,work.presentation.teaching_resource.title,work.presentation.teaching_resource.media_sources`)
      .then(response => {
        this.setState({ work: response.data.work, loading: false })
      })
      .catch(() => this.setState({'loading': false, work: { status: 'unpublished', policy: {can_edit: false}}}))
  }

  onImageRotation (image, index) {
    let work = update(this.state.work, {media: {[index]: {image_url: {$set: image}}}})
    this.setState({ work })
  }

  onResourceAddition (resource) {
    let work = update(this.state.work, {resources: {$push: [resource]}})
    this.setState({ work })
  }

  onExemplarMarked (mark) {
    let work = update(this.state.work, {exemplar: {$set: mark}})
    this.setState({ work })
  }

  onLike (like, count) {
    let work = update(this.state.work, {is_liked: {$set: like}, likes_count: {$set: count.likes_count}})
    this.setState({ work })
  }

  onBookmark (bookmark) {
    let work = update(this.state.work, {bookmarked_by_me: {$set: bookmark}})
    this.setState({ work })
  }

  onCommenting (comment) {
    let work = update(this.state.work, {comments: {$push: [comment]}})
    this.setState({ work, lastComment: comment.id })
  }

  onCommentFlag (index) {
    let work = update(this.state.work, {comments: {[index]: {status: {$set: 'flagged'}}}})
    this.setState({ work })
  }

  onEditWorkInfos (editedWork) {
    let work = update(this.state.work, {title: {$set: editedWork.title}, description: {$set: editedWork.description}})
    this.setState({ work })
  }

  onEditWorkInfosTags (tags) {
    let work = update(this.state.work,  {tags: {$set: tags}})
    this.setState({ work })
  }

  backToSearch () {
    localStorage.setItem('backToSearch', JSON.stringify(this.props.location.state))
    this.props.history.goBack()
  }

  render () {
    let {work} = this.state
    let {location} = this.props
    var button = location && location.state && <div className='btn btn-overlay work__back' onClick={this.backToSearch}><FaCaretLeft />Back</div>
    return (
      <article className='workView'>
        {this.state.loading && <WorkLoading />}
        {!this.state.loading && <div>
          {button}
          {work.id && <WorkMedia {...work} user={this.state.user} onImageRotation={this.onImageRotation} onResourceAddition={this.onResourceAddition} onExemplarMarked={this.onExemplarMarked} />}
          {work.status !== 'published' && (work.policy && !work.policy.can_edit) && <WorkNoAccess onBack={this.backToSearch} />}
          {work.status === 'published' && <WorkStats {...work} onLike={this.onLike} onBookmark={this.onBookmark} loading={this.state.loading} user={this.state.user} />}
        </div>}
        <WorkSidebar {...work} onCommenting={this.onCommenting} onCommentFlag={this.onCommentFlag} onEditWorkInfos={this.onEditWorkInfos} onEditWorkInfosTags={this.onEditWorkInfosTags} loading={this.state.loading} lastComment={this.state.lastComment} user={this.state.user} />
      </article>
    )
  }
}

Work.propTypes = {
  location: PropTypes.object,
  router: PropTypes.object,
  params: PropTypes.object,
  workId: PropTypes.number
}

export default Work



// WEBPACK FOOTER //
// ./components/work/Work.js